import { createContext, useContext, useState } from 'react';

const DrawerContext = createContext(null);

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within DrawerProvider');
  }
  return context;
};

export const DrawerProvider = ({ children, ...props }) => {
  const [drawer, setDrawer] = useState({
    show: false,
    component: null,
    props: null,
  });

  const openDrawer = ({ component, props = {} }) => {
    setDrawer({
      show: true,
      component,
      props,
    });
  };

  const closeDrawer = () => {
    setDrawer({
      show: false,
      component: null,
    });
  };

  const setDrawerComponent = ({ component }) => {
    setDrawer({
      ...drawer,
      component,
    });
  };

  return (
    <DrawerContext.Provider
      value={{ drawer, openDrawer, closeDrawer, setDrawerComponent }}
      {...props}
    >
      {children}
    </DrawerContext.Provider>
  );
};
